import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white border border-gray-200 rounded-lg shadow", `p-${_ctx.padding}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}